// extracted by mini-css-extract-plugin
export var hidden = "_tw-0";